import { useEffect, useMemo, useState } from 'react';
import { subscribeColocadores } from '../services/colocadoresService';

const VACIO = { lista: [], isLoading: false, error: null };

/**
 * Catálogo de colocadores en vivo (solo personal interno: las reglas no se lo dejan leer
 * a un productor, que ve los colocadores embebidos en cada licitación).
 *
 * @param {{ enabled?: boolean }} options - false = no se suscribe (modal cerrado).
 * @returns {{ colocadores: Array, activos: Array, isLoading: boolean, error: Error|null }}
 */
export const useColocadores = ({ enabled = true } = {}) => {
  const [estado, setEstado] = useState({ ...VACIO, isLoading: enabled });

  useEffect(() => {
    if (!enabled) {
      setEstado(VACIO);
      return undefined;
    }
    setEstado(prev => ({ ...prev, isLoading: true }));
    return subscribeColocadores(
      (lista) => setEstado({ lista, isLoading: false, error: null }),
      (error) => setEstado({ lista: [], isLoading: false, error }),
    );
  }, [enabled]);

  const activos = useMemo(() => estado.lista.filter(c => c.active !== false), [estado.lista]);
  return { colocadores: estado.lista, activos, isLoading: estado.isLoading, error: estado.error };
};
